<template>
    <layout>
        <template slot="content">
            <header class="content__title">
                <h1>{{ title }}</h1>
            </header>
            <list :entries="entries"></list>
        </template>
    </layout>
</template>

<script>
    import Layout from '@/layout/Boxed'
    import List from '@/components/List'
    import NavigationBar from '@/layout/NavigationBar'

    export default {
        data() {
            return {
                listData: []
            }
        },

        props: {
            module: {default: 'Home'},
        },

        components: {
            'layout': Layout,
            'list': List,
            'navigation-bar': NavigationBar
        },

        computed: {
            entries() {
                let list = this.$store.getters.getList(this.module)
                if(list){
                    return list.entries
                }

                return []
            },
            title() {
                let structure = this.$store.getters.getStructure
                if(structure) {
                    return this.$t('LBL_LIST').replace('$module$', structure.modules[this.module].label)
                }
            }
        },

        mounted() {
            this.$store.dispatch('fetchList', {module: this.module})
        }
    }
</script>